import { useModalContext } from '#pplx/frontend/aether/modals/context/useModalContext.js';
import { useLossAversionStorage } from '#pplx/frontend/apps/ask/search/loss-aversion/useLossAversionStorage.js';
import { useIsUserLoggedIn } from '#pplx/frontend/auth/userHooks.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { usePathname } from '#pplx/frontend/router/usePathname.js';
import { useCallback, useMemo } from 'react';
const ThreadLossAversionModalDynamic = Dynamic(async () => {
    const { ThreadLossAversionModal } = await import('#pplx/frontend/apps/ask/search/modals/ThreadLossAversionModal.js');
    return { default: ThreadLossAversionModal };
});
export const useLossAversion = () => {
    const { lossAversionStatus, setLossAversionStatus } = useLossAversionStorage();
    const currentPath = usePathname();
    const isUserLoggedIn = useIsUserLoggedIn();
    const shouldShowLossAversionModal = useMemo(() => !isUserLoggedIn && lossAversionStatus === 'allowed' && currentPath?.startsWith('/search'), [isUserLoggedIn, lossAversionStatus, currentPath]);
    const { openModal } = useModalContext();
    const handleOpenLossAversion = useCallback((args) => {
        openModal(ThreadLossAversionModalDynamic, args, { replace: true });
        setLossAversionStatus('cooldown');
    }, [openModal, setLossAversionStatus]);
    return useMemo(() => ({ shouldShowLossAversionModal, handleOpenLossAversion }), [shouldShowLossAversionModal, handleOpenLossAversion]);
};
//# sourceMappingURL=useLossAversion.js.map